import { render, staticRenderFns } from "./UpdateInvoice.vue?vue&type=template&id=05f008db&scoped=true"
import script from "./UpdateInvoice.vue?vue&type=script&lang=js"
export * from "./UpdateInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f008db",
  null
  
)

export default component.exports